import { Phone } from "@homesusa/core";

export function upsertPhoneByType(
  phones: Phone[] | undefined | null,
  phone: Phone
): Phone[] {
  const { number, phoneType } = phone;

  if (!phones) {
    return [phone];
  }

  if (phones.some((existing) => existing.phoneType === phoneType)) {
    return phones.map((existing) =>
      existing.phoneType === phoneType ? { ...existing, number } : existing
    );
  }

  return [...phones, phone];
}
